<template>
    <div ref="circleCanvas" class="circle_canvas"></div>
</template>

<script>
    export default {
        name: "CircleCanvas",
        data () {
            return {
                circleCanvas: null
            }
        },
        props: {
            info: {
                type: Object,
                default: () => {
                    return {
                        name: '百分比',
                        value: 0,
                        color: '#2996F3'
                    }
                }
            }
        },
        mounted () {
            this.drawCanvas(this.info)
        },
        methods: {
            transfer(num){
                if(isNaN(num)){
                    return '0%'
                }else{
                    return (Math.ceil(num * 1000) / 10) + '%'
                }
            },
            transferToValue (num){
                if(isNaN(num)){
                    return 0
                }else{
                    return num
                }
            },
            drawCanvas (data) {
                if (this.circleCanvas) {
                    this.circleCanvas.dispose();
                    this.circleCanvas = null;
                }
                const value = data && data.value
                const name = data && data.name
                const color = data && data.color
                this.circleCanvas =  this.$echarts.init(this.$refs.circleCanvas)
                this.circleCanvas.setOption( {
                    title: {
                        text: name,
                        top:'30%',
                        left: '70',
                        subtext: this.transfer(value),
                        textStyle: {
                            color:'rgba(153,153,153,1)',
                            fontSize: '12',
                            fontWeight: 'bold',
                        },
                        subtextStyle:{
                            fontSize: '30',
                            fontWeight: 'bold',
                            color: color
                        },
                        textAlign:'center'
                    },
                    color:[ color,'#ECECEC'],
                    series: [
                        {
                            name:'访问来源',
                            type:'pie',
                            radius: ['68%', '85%'],
                            avoidLabelOverlap: false,
                            hoverAnimation: true,
                            label: {
                                normal: {
                                    show: false,
                                    position: 'center',
                                }
                            },
                            data:[
                                {
                                    value:this.transferToValue(value),
                                    emphasis: {
                                        itemStyle:{
                                            color: color
                                        }
                                    }
                                },
                                {
                                    value:1-this.transferToValue(value),
                                    emphasis: {
                                        itemStyle:{
                                            color: '#ECECEC'
                                        }
                                    }
                                }
                            ]
                        }
                    ]
                });
            }
        }
    }
</script>

<style lang="scss" scoped>
    .circle_canvas{
        width: 150px;
        height: 150px;
    }
</style>
